import React from "react";

// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Button from "components/base/Button";
import BtnContent from "../Btn/components/BtnContent";

// ** Custom Styles
import { resolveProps, marginable } from "styles/styledComponentsMixins";

// #####################################################

const StyledButtonText = styled(({ ...props }) => (
	<Button {...resolveProps(props, marginable)} />
))(() => {
	return css`
		position: relative;
		display: inline-block;
		background-color: transparent;
		cursor: pointer;
		font-size: 0.9rem;
		color: var(--dz-sys-text-color);

		${({ isLanding }) =>
			isLanding &&
			`
			color: var(--dz-ref-color-white);
		`}

		${marginable.css}

		&:hover,
        &:focus {
			text-decoration: underline;
		}

		&:disabled {
			opacity: 1;
		}
	`;
});

// #####################################################

export const ButtonText = ({ label, children, ...rest }) => {
	const textContent = children || label;

	// #####################################################

	return (
		<StyledButtonText {...rest}>
			<BtnContent textContent={textContent} />
		</StyledButtonText>
	);
};

// #####################################################
